<template>
  <Tabs change-on-focus class="tw-flex tw-flex-col">
    <TabList>
      <Tab>{{ t('tabs.launch') }}</Tab>
      <Tab>{{ t('tabs.restart') }}</Tab>
      <Tab>{{ t('tabs.wiring') }}</Tab>
      <Tab>{{ t('tabs.networking') }}</Tab>
      <Tab>{{ t('tabs.monitoring') }}</Tab>
      <Tab>{{ t('tabs.dev') }}</Tab>
    </TabList>

    <TabPanels class="tw-mt-10">
      <Launch />
      <Restart />
      <Wiring />
      <Networking />
      <Monitoring />
      <Dev />
    </TabPanels>
  </Tabs>
</template>

<script setup>
import { useI18n } from 'vue-i18n';

import { Tab, TabList, TabPanels, Tabs } from '@slideslive/fuse-kit/vue';

import Dev from './Dev.vue';
import Launch from './Launch.vue';
import Monitoring from './Monitoring.vue';
import Networking from './Networking.vue';
import Restart from './Restart.vue';
import Wiring from './Wiring.vue';

const { t } = useI18n();
</script>
